/**
 * @file index.tsx
 *
 * @fileoverview Renders blog quote row.
 */

import Image from '~/jobiqo/components/Image';
import { Image as ImageType } from '~/jobiqo/types/types';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { Quote } from '~/vcl/molecules/14-quote';
import styles from './quote.module.scss';
import { useIsMobile } from '~/vcl/hooks/useIsMobile';

interface BlogQuoteRowProps {
  /**
   * The quote text.
   */
  text: string;
  /**
   * The quote's author.
   */
  author?: string;
  /**
   * The image.
   */
  image?: ImageType;
}

export default function BlogQuoteRow({
  text,
  author,
  image,
}: BlogQuoteRowProps) {
  return (
    <FlexItems justifyContent="center">
      <Quote
        text={text}
        author={author}
        {...(image && {
          Image: (
            <div
              className={`${styles.imageWrapper} ${
                useIsMobile() ? styles.imageWrapperMobile : ''
              }`}
            >
              <Image
                src={image.url}
                alt={image.alt ?? ''}
                {...(image.title && { title: image.title })}
                width={null}
                height={null}
              />
            </div>
          ),
        })}
      />
    </FlexItems>
  );
}

export { BlogQuoteRow };
